import { render, staticRenderFns } from "./AddTaskComponent.vue?vue&type=template&id=74c579f6&scoped=true&"
import script from "./AddTaskComponent.vue?vue&type=script&lang=js&"
export * from "./AddTaskComponent.vue?vue&type=script&lang=js&"
import style0 from "./AddTaskComponent.vue?vue&type=style&index=0&id=74c579f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74c579f6",
  null
  
)

export default component.exports